<template>
    <div>
        <SmartButton
                @click="showReasonModal()"
                class="smart-button--secondary"
                style="height: 30px"
                >VER</SmartButton>

        <SmartModalPayload v-if="modal" v-bind="modal">
                <div class="flex w-full justify-end">
                    <SmartButton
                        @click="hideModal()"
                        class="smart-button--tertiary"
                        style="height: 30px"
                        >Fechar</SmartButton>
                </div>

                <SmartListItem
                    v-for="(detail, index) in modal.text"
                    :key="`${index}-reason`"
                    class="mx-2 w-full"
                    > {{ detail }}
                </SmartListItem>
        </SmartModalPayload>
    </div>
</template>

<script>
export default {
    props: {
        reason: {
            type: String,
            default: () => ""
        }
    },
    data() {
        return {
            modal: null,
        };
    },
    methods: {
        hideModal() {
            this.modal = false;
        },
        showReasonModal() {
            this.modal = true;
            this.modal = {
                title: "Motivo(s) do(s) erro(s)",
                text: this.reason ? this.transformReason() : ["Sem motivo!"],
            };
        },
        transformReason() {
            return this.reason.split(';');
        }
    }
}
</script>
